<template>
    <rkm-modal
        large
        :loading="loading"
        ref="Modal"
        :title="title"
    >

        <template v-if="indexArea != null && area != null && equipes != null">

            <rkm-form
                ref="FormMicroarea"
                show-legend
            >

                <rkm-row class="flex-nowrap">

                    <rkm-col class="flex-grow-1">

                        <rkm-form-input
                            label="Microárea"
                            v-model="model.descricao"
                            :validations="validations.descricao"
                            number
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0 text-nowrap">

                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.FormMicroarea.validate(add)"
                        >
                            Incluir
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-table
                :items="area.microareas"
                :fields="fields"
                ref="Table"
            >
                <template v-slot:cell(actions)="{ index, item }">

                    <rkm-button
                        :disabled="equipes.find(equipe => equipe.microareaId == item.id) !== undefined"
                        @click="handleDestroy(index)"
                        color="danger"
                        title="Excluir"
                        small
                    >
                        <rkm-icon icon="trash"/>
                    </rkm-button>
                </template>
            </rkm-table>
        </template>

        <template #footer>

            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Fechar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

// Vuex.
import { mapGetters } from 'vuex'

// Mixins
import { object } from "@/mixins";

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {
            return {
                descricao: { required: true, max: 11, },
            }
        },
        fields() {

            return [
                { key: 'descricao', label: 'Descrição', sortable: true, },
                { key: 'actions', label: 'Ações', class: 'col-min text-center', },
            ]
        },
        title() {

            return this.area
                ? this.area.descricao
                    ? `Microárea - (INE: ${this.area.numeroIne} - Área: ${this.area.descricao})`
                    : `Microárea - (INE: ${this.area.numeroIne})`
                : ''
        }
    },
    data: () => ({
        items: [],
        indexArea: null,
        area: {},
        microareas: [],
        equipes: [],
        model: {
            id: null,
            descricao: null,
        },
    }),
    methods: {
        open(indexArea, area, equipes) {

            this.indexArea = indexArea
            this.area = area

            this.area.numeroIne = this.area.numeroIne ? this.area.numeroIne.padStart(10, '0') : '';
            this.equipes = equipes

            this.area.microareas = this.clone(area.microareas)

            this.$refs.Modal.show()
        },
        async verificaDuplicidade() {

            const existeMicroarea = this.area.microareas
                .find(microarea => microarea.descricao == this.model.descricao)

            if (existeMicroarea) {

                this.showValidationNotification('A microárea já existe')

                return false
            }

            return true
        },
        add() {

            this.verificaDuplicidade()
                .then(isValid => {

                    if (!isValid) return

                    this.area.microareas.push(this.clone(this.model))

                    this.limpaFormulario()
                })
        },
        limpaFormulario() {

            this.model.descricao = null,

            this.$nextTick()
                .then(() => this.$refs.FormMicroarea.resetValidator())
        },
        handleDestroy(indexMicroarea) {

            const destroy = async () => this.area.microareas.splice(indexMicroarea, 1)

            this.showDeleteConfirmation(
                'Deseja realmente excluir a Microárea?',
                destroy,
                this.handleError
            )
        },
        cancel() {

            this.$refs.Modal.hide()
        },
    },
    mixins: [ object ],
}
</script>